import { render } from "./DigitalContentSectionItem.vue?vue&type=template&id=683c98dc"
import script from "./DigitalContentSectionItem.vue?vue&type=script&lang=js"
export * from "./DigitalContentSectionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__